import React from "react";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";

import * as iconStyles from "./Icon.module.css";

library.add(fab, fas, far);

const Icon = ({ onClick, props }) => {
  const {
    name,
    isBrand,
    isRegular,
    color,
    size,
    hasBackground,
    backgroundColor,
    circleColor,
  } = props;
  const _type = isBrand ? "fab" : isRegular ? "far" : "fas";

  return (
    <span
      onClick={onClick || null}
      className={`${iconStyles.icon} ${iconStyles[color]} ${
        hasBackground && iconStyles.hasBackground
      } ${backgroundColor && iconStyles[backgroundColor]} ${
        circleColor && iconStyles[`circle${circleColor}`]
      }`}
    >
      {props && <FontAwesomeIcon icon={[_type, name]} size={size} />}
    </span>
  );
};

export default Icon;
